"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _utils = require("../../../utils");

var _constants = require("../../constants");

var _utils2 = require("../../utils");

var _DefaultTab = _interopRequireDefault(require("./DefaultTab"));

var _helperComponents = require("./helperComponents");

var _core = require("@emotion/core");

var _excluded = ["aria-label", "colorScheme", "onTabSelect", "shouldActivateManually", "selectedTab", "shouldWrap", "tabGroup", "tabs"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var DefaultTabBarBase = function DefaultTabBarBase(_ref) {
  var ariaLabel = _ref['aria-label'],
      colorScheme = _ref.colorScheme,
      onTabSelect = _ref.onTabSelect,
      shouldActivateManually = _ref.shouldActivateManually,
      selectedTab = _ref.selectedTab,
      shouldWrap = _ref.shouldWrap,
      tabGroup = _ref.tabGroup,
      tabs = _ref.tabs,
      forwardedProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var tabsRefMap = (0, _react.useRef)({});

  var handleKeyPressForTabs = function handleKeyPressForTabs(_ref2) {
    var event = _ref2.event,
        onTabSelect = _ref2.onTabSelect,
        shouldActivateManually = _ref2.shouldActivateManually,
        tabs = _ref2.tabs,
        tabsRefMap = _ref2.tabsRefMap,
        targetValue = _ref2.targetValue;
    var targetIndex = tabs.findIndex(function (_ref3) {
      var value = _ref3.value;
      return value === targetValue;
    });
    var shouldActivateAutomatically = !shouldActivateManually;

    switch (event.key) {
      case _utils.EventKeys.ARROW_LEFT:
        if (targetIndex === 0) {
          tabsRefMap.current[tabs.length - 1].focus();

          if (shouldActivateAutomatically) {
            onTabSelect(tabs[tabs.length - 1].value);
          }

          break;
        }

        tabsRefMap.current[targetIndex - 1].focus();

        if (shouldActivateAutomatically) {
          onTabSelect(tabs[targetIndex - 1].value);
        }

        break;

      case _utils.EventKeys.ARROW_RIGHT:
        tabsRefMap.current[(targetIndex + 1) % tabs.length].focus();

        if (shouldActivateAutomatically) {
          onTabSelect(tabs[(targetIndex + 1) % tabs.length].value);
        }

        break;
      // preventDefault to avoid scrolling while selecting an option

      case _utils.EventKeys.SPACEBAR:
        event.preventDefault();

        if (shouldActivateManually) {
          onTabSelect(targetValue);
        }

        break;

      case _utils.EventKeys.ENTER:
        if (shouldActivateManually) {
          onTabSelect(targetValue);
        }

        break;

      case _utils.EventKeys.HOME:
        tabsRefMap.current[0].focus();

        if (shouldActivateAutomatically) {
          onTabSelect(tabs[0].value);
        }

        break;

      case _utils.EventKeys.END:
        tabsRefMap.current[tabs.length - 1].focus();

        if (shouldActivateAutomatically) {
          onTabSelect(tabs[tabs.length - 1].value);
        }

        break;

      default:
        return;
    }
  };

  return (0, _core.jsx)(_helperComponents.TabList, (0, _extends2.default)({}, (0, _utils.pickDataProps)(forwardedProps), {
    role: "tablist",
    gridGap: "S500",
    flexWrap: shouldWrap ? 'wrap' : 'nowrap',
    "aria-label": ariaLabel,
    overflow: "auto visible",
    padding: [_constants.TAB_BAR_PADDING, _constants.TAB_BAR_PADDING, 0, _constants.TAB_BAR_PADDING],
    shouldWrap: shouldWrap
  }), tabs.map(function (_ref4, index) {
    var label = _ref4.label,
        value = _ref4.value,
        href = _ref4.href,
        triggerProps = _ref4.triggerProps;
    var tabId = (0, _utils2.getTabId)(tabGroup, value);
    var panelId = (0, _utils2.getPanelId)(tabId);
    return (0, _core.jsx)(_DefaultTab.default, (0, _extends2.default)({}, triggerProps, {
      id: tabId,
      ref: function ref(el) {
        return tabsRefMap.current[index] = el;
      },
      key: value,
      href: href,
      onKeyDown: function onKeyDown(event) {
        return handleKeyPressForTabs({
          event: event,
          targetValue: value,
          tabs: tabs,
          shouldActivateManually: shouldActivateManually,
          tabsRefMap: tabsRefMap,
          onTabSelect: onTabSelect
        });
      },
      onClick: function onClick() {
        return onTabSelect(value);
      },
      isSelected: value === selectedTab,
      colorScheme: colorScheme,
      shouldWrap: shouldWrap,
      "aria-controls": panelId,
      dataTestId: value.toString()
    }), label);
  }));
};

var DefaultTabBar = (0, _utils.withTestAttributes)({
  component: 'StencilTabBar'
})(DefaultTabBarBase);
DefaultTabBar.displayName = 'DefaultTabBar';
var _default = DefaultTabBar;
exports.default = _default;